export default __webpack_public_path__ + "static/fakegoogle_3-6e3c5a67a3ac19339cefc84ad2ab6b4c.jpg";